module.exports = __webpack_public_path__ + "img/1920x800-01.01681cf9.jpg";